/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgNotification32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M16 8.25a4.95 4.95 0 00-4.95 4.95v.276a2.966 2.966 0 01-1.482 2.573c-.647.372-1.318.963-1.318 1.818 0 .65.396 1.15.836 1.497.448.353 1.05.639 1.727.864 1.362.454 3.196.722 5.187.722s3.825-.268 5.187-.722c.677-.226 1.279-.51 1.727-.864.44-.347.836-.847.836-1.497 0-.855-.67-1.446-1.317-1.817h-.001a2.965 2.965 0 01-1.482-2.574V13.2A4.95 4.95 0 0016 8.25zm-3.45 4.95a3.45 3.45 0 016.9 0v.276c0 1.593.847 3.08 2.236 3.875.25.143.404.275.488.377.04.05.06.085.068.106.008.02.008.03.008.033 0 .003 0 .026-.031.078a.99.99 0 01-.233.241c-.26.205-.684.423-1.274.62-1.171.39-2.837.644-4.712.644-1.875 0-3.541-.254-4.713-.645-.59-.196-1.012-.414-1.273-.619a.989.989 0 01-.233-.241c-.031-.052-.031-.075-.031-.078 0-.004 0-.013.008-.033a.428.428 0 01.068-.106c.084-.102.237-.234.488-.377a4.466 4.466 0 002.236-3.875V13.2zm6.276 9a.75.75 0 10-1.374-.6 1.584 1.584 0 01-2.904 0 .75.75 0 10-1.374.602 3.086 3.086 0 005.652-.002z'
      />
      <circle
        cx={22}
        cy={9}
        r={5}
        fill='#00D3A1'
        stroke='#fff'
        strokeWidth={2}
      />
    </svg>
  );
}

export default SvgNotification32;
